import router from "../router/index";
import axios from "axios";
import { Message,Loading } from "element-ui";
/*国际化*/
let loading;
let loadingNum = 0;



function getHost() {
   if(window.location.href.indexOf('local') !==-1 || window.location.href.indexOf('dev') !==-1){
     return 'https://guanlidev.xhhappy.cn'
   }
   return 'https://guanli.xhhappy.cn'
}



function startLoading() {
  if (loadingNum == 0) {
    loading = Loading.service({
      lock: true,
      text: "加载中……",
      background: "rgba(0, 0, 0, 0.7)"
    });
  }
  loadingNum++;
}

function endLoading() {
  loadingNum--;
  if (loadingNum <= 0) {
    loading.close();
  }
}

axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
//http request 拦截器
axios.interceptors.request.use(
  config => {
    // startLoading();
    config.headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer${localStorage.getItem("token")}`
    };
    config.withCredentials = false
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
let oneShow = true;
//http response 拦截器
axios.interceptors.response.use(
  response => {
    if(response.data.code !== 0 ){
      if(response.data.code !== 400020 ){
        Message({
          type: "error",
          center: true,
          message: response.data.message
        })
      }

      // window.localStorage.removeItem('userInfo')
      // window.localStorage.removeItem('openid')
      // window.localStorage.removeItem('navList')
      // window.localStorage.removeItem('token')
      // window.localStorage.removeItem('style')
      router.replace({path: '/login', query: {}})
    }
    return response;
  },
  err => {
    return Promise.reject(err);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(getHost() + url, {
        params: {
          ...params,
          openid: localStorage.getItem("openid")
        }
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(getHost() + url, data={
      ...data,
      openid: localStorage.getItem("openid")
    }).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js